import { createContext, useState, useEffect } from 'react';
import languages from '../data/languages';

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  // Garante que exista um valor inicial válido no localStorage
  useEffect(() => {
    const storedLanguage = localStorage.getItem('Language');

    if (!storedLanguage) {
      localStorage.setItem('Language', 'Português'); // Corrigido: acento correto
    }
  }, []);

  // Agora, garantido que o valor existe no localStorage
  const storedLanguage = localStorage.getItem('Language');
  const initialIndex = languages.findIndex(
    l => l.language === storedLanguage
  );

  // fallback para 0 caso não encontre
  const [languageIndex, setLanguageIndex] = useState(
    initialIndex !== -1 ? initialIndex : 0
  );

  // Atualiza o localStorage sempre que languageIndex mudar
  useEffect(() => {
    localStorage.setItem('Language', languages[languageIndex].language);
  }, [languageIndex]);

  const toggleLanguage = () => {
    setLanguageIndex(prev => (prev === 0 ? 1 : 0));
  };

  return (
    <LanguageContext.Provider value={{ languageIndex, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}
